import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
import ConnectionDetails from "./ConnectionDetails";
import Endpoint from "./Endpoints";
import { SubtabPortal } from "@/components/Integrations/ManageConnection/ManageConnectionPopupContext";

const Connection = ({
  connectionDetails,
  setConnectionDetails,
  showErrors,
  setTabErrors,
  connectionId,
  selectedEndpointId,
  setSelectedEndpointId,
  tabValue,
  setTabValue,
}) => {
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container>
      <SubtabPortal>
        <ShepTabs
          variant="tertiary"
          value={tabValue}
          onChange={handleTabChange}
          style={{
            marginBottom: "0px",
            backgroundColor: "var(--default-light)",
          }}
        >
          <ShepTab
            variant="tertiary"
            key="1"
            label={"Connection Details"}
            style={{ minWidth: "250px", margin: "0px 20px" }}
          />
          <ShepTab variant="tertiary" key="2" label={"Endpoint"} />
        </ShepTabs>
      </SubtabPortal>
      {tabValue === 0 && (
        <ConnectionDetails
          connectionDetails={connectionDetails}
          setConnectionDetails={setConnectionDetails}
          showErrors={showErrors}
          setHasErrors={(hasErrors) =>
            setTabErrors((prev) => ({
              ...prev,
              connectionDetails: hasErrors,
            }))
          }
          connectionId={connectionId}
        />
      )}
      {tabValue === 1 && (
        <Endpoint
          selectedEndpointId={selectedEndpointId}
          setSelectedEndpointId={setSelectedEndpointId}
        />
      )}
    </Container>
  );
};

export default Connection;
